import { render, staticRenderFns } from "./PcRiskController.vue?vue&type=template&id=676e416b&scoped=true&"
import script from "./PcRiskController.vue?vue&type=script&lang=js&"
export * from "./PcRiskController.vue?vue&type=script&lang=js&"
import style0 from "./PcRiskController.vue?vue&type=style&index=0&id=676e416b&prod&lang=scss&"
import style1 from "./PcRiskController.vue?vue&type=style&index=1&id=676e416b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e416b",
  null
  
)

/* custom blocks */
import block0 from "./PcRiskController.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports